var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"label":_vm.$vuetify.lang.t(_vm.label),"items":_vm.list,"clearable":"","hide-no-data":"","hide-selected":"","item-text":"name","item-value":"code","autocomplete":"country"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }